import React from "react";
import ReactCodeInput from "react-code-input";
import "./style.css";

const props = {
  className: "custom-code-input",
  inputStyle: {
    fontFamily: "Roboto",
    width: 40,
    height: 40,
    borderRadius: 5,
    border: "1px solid #A5ABB3",
    margin: 3,
    fontSize: "1.5rem",
    textAlign: "center",
  },
};

const CodeInput = ({ code, setCode }) => {
  return (
    <ReactCodeInput
      type="number"
      fields={6}
      {...props}
      value={code}
      onChange={setCode}
    />
  );
};

export default CodeInput;
